import { FC } from "react";
import { App } from "@capacitor/app";
import { useTranslation } from "react-i18next";
import { useStyles } from "./ExitAppDialog.style";
import { Dialog } from "../../core/Dialog/Dialog";
import { Typography } from "../../core/Typography/Typography";
import { TypographyVariant } from "../../../constants/typography";
import { isAndroidAppTv, isTizen, isWebos } from "../../../utils/platform";

interface ExitAppDialogProps {
  open: boolean;
  onClose: () => void;
}

export const exitApp = () => {
  if (isAndroidAppTv) {
    App.exitApp();
  }
  if (isTizen) {
    window?.tizen?.application?.getCurrentApplication?.()?.exit?.();
  }
  if (isWebos) {
    window?.close();
  }
};

export const ExitAppDialog: FC<ExitAppDialogProps> = ({ open, onClose }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Dialog
      mainAction={{
        text: t("Console_Exit App"),
        onClick: exitApp,
        id: "exit",
      }}
      secondAction={{
        text: t("Console_Cancel"),
        onClick: onClose,
        id: "close-dialog",
        "data-button-sound": "back",
      }}
      open={open}
    >
      <div className={classes.content}>
        <Typography
          variant={TypographyVariant.HeadingH3Bold}
          className={classes.title}
        >
          {t("Console_Power Off")}
        </Typography>
        <Typography
          variant={TypographyVariant.BodyB3Medium}
          className={classes.description}
        >
          {t(
            "Console_This will close ONMO+ and return you to the TV home screen.",
          )}
        </Typography>
      </div>
    </Dialog>
  );
};
